import { Button, Grid, TextField, Typography } from '@mui/material';
import React from 'react';
import MainCard from 'ui-component/cards/MainCard';
// import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useEffect } from 'react';
import { generateAgentCode, getVideoKycRequests } from 'API/VideoKyc/api';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// import { useMemo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { Stack } from '@mui/system';
import BackdropLoader from './Components/General/Loader';
import Pagination from '@mui/material/Pagination';
import SubCard from 'ui-component/cards/SubCard';
import { formattedName } from 'utils/DateFormater';

// import { ProvideDsVideoKycApproval } from 'API/Ds Approval/api';

const VideoKyc = () => {
  // const columns = [
  //   // { field: 'id', headerName: 'ID', width: 70 },
  //   { field: 'aadhaar_name', sortable: false, headerName: 'Name', width: 200 },
  //   { field: 'user_type',
  //     sortable: false,
  //     headerName: 'User Type',
  //     width: 120,
  //     renderCell:(params)=>
  //       (
  //         <Typography variant='subtitle1'>{params.row.user_type}</Typography>
  //       )
  //   },
  //   {
  //     field: 'mobile_number',
  //     sortable: false,
  //     headerName: 'Mobile Number',
  //     width: 160
  //   },
  //   {
  //     field: 'aadhar_number',
  //     headerName: 'Aadhaar Number',
  //     sortable: false,
  //     width: 160
  //   },
  //   {
  //     field: 'pan_number',
  //     headerName: 'Pan Card',
  //     sortable: false,
  //     width: 160
  //   },
  //   {
  //     field: 'email_address',
  //     headerName: 'Email Address',
  //     sortable: false,
  //     width: 250
  //   },
  //   {
  //     field: 'create_agent_code',
  //     headerName: 'Create agent code',
  //     sortable: false,
  //     renderCell: (params) =>
  //       params.row['user_type'] &&
  //       (params.row['user_type'] === 'DS' ||
  //         params.row['user_type'] === 'ds' ||
  //         params.row['user_type'] === 'MDS' ||
  //         params.row['user_type'] === 'mds' ||
  //       params.row['user_type'] === 'fos'
  //       ) ? (
  //         <Button
  //           variant="contained"
  //           color="primary"
  //           // disabled={true}
  //           onClick={() => handleButtonClick(params.row)}
  //         >
  //           Approve
  //         </Button>
  //       ) : (
  //         <Button variant="contained" color="primary" disabled={true} onClick={() => handleButtonClick(params.row)}>
  //           Create Code
  //         </Button>
  //       ),

  //     width: 200
  //   }
  // ];

  const [Data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [AlertType, setAlertType] = useState('success');
  const [AlertMessage, setAlertMessage] = useState(null);
  const [AlertOpen, setAlertOpen] = useState(false);
  const [Page, setPage] = useState(1);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  // const [SearchFilter, setSearchFilter] = useState();
  const [Filters, setFilters] = useState({
    agent_name: '',
    mobile_number: '',
    email_address: ''
  });

  // const handleFilterchange = (value) => {
  //   setSearchFilter(value);
  // };

  const handleAlertOpen = () => {
    setAlertOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleGet = () => {
    getVideoKycRequests(Filters, Page, setData, setIsLoading);
  };

  useEffect(() => {
    handleGet();
  }, [Page]);

  const handleButtonClick = (data) => {
    generateAgentCode(data, setAlertMessage, setAlertType, handleAlertOpen, setData, setIsLoading, Filters, Page);
    // setFilterId(data._id)
  };

  // const handleDsApprove=(params)=>{
  //     ProvideDsVideoKycApproval(params._id,setIsLoading,handleAlertOpen,setAlertMessage,setAlertType,handleGet)
  //     setFilterId(params._id)

  // }

  const handleFiltersChange = (name, value) => {
    if (name === 'agent_name') {
      if (/^[a-zA-Z ]*$/.test(value)) {
        setFilters((prevValue) => ({
          ...prevValue,
          [name]: value
        }));
      }
    } else if (name === 'mobile_number') {
      if (/^[0-9]*$/.test(value)) {
        setFilters((prevValue) => ({
          ...prevValue,
          [name]: value
        }));
      }
    } else {
      if (/^[a-zA-Z@_.]*$/.test(value)) {
        setFilters((prevValue) => ({
          ...prevValue,
          [name]: value
        }));
      }
    }
  };

  const handleClear = () => {
    setFilters({
      agent_name: '',
      mobile_number: '',
      email_address: ''
    });
    getVideoKycRequests(
      {
        agent_name: '',
        mobile_number: '',
        email_address: ''
      },
      Page,
      setData,
      setIsLoading
    );
  };

  // console.log("Data", filteredRows);
  return (
    <Grid container>
      <BackdropLoader open={isLoading} />
      <Grid item xs={12} mb={1}>
        <SubCard>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item md={3} xs={6}>
              <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                {' '}
                Agent Name
              </Typography>
              <TextField
                id="outlined-basic"
                variant="outlined"
                value={Filters.agent_name ? Filters.agent_name : ''}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: '2px solid #A9A9A980 50%', // change border color
                    borderRadius: '8px'
                  },
                  '& fieldset': {
                    borderColor: '#A9A9A980',
                    borderRadius: '8px' // default border color
                  }
                }}
                size="small"
                onChange={(e) => handleFiltersChange('agent_name', e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item md={3} xs={6} sx={{ visibility: 'hidden' }}>
              <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                {' '}
                Email Address
              </Typography>
              <TextField
                id="outlined-basic"
                variant="outlined"
                size="small"
                value={Filters.email_address ? Filters.email_address : ''}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: '2px solid #A9A9A980 50%', // change border color
                    borderRadius: '8px'
                  },
                  '& fieldset': {
                    borderColor: '#A9A9A980',
                    borderRadius: '8px' // default border color
                  },
                  visibility: 'hidden'
                }}
                onChange={(e) => handleFiltersChange('email_address', e.target.value)}
                fullWidth
              />
            </Grid>
            <Grid item md={3} xs={6} sx={{ visibility: 'hidden' }}>
              <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                {' '}
                Mobile Number
              </Typography>
              <TextField
                id="outlined-basic"
                variant="outlined"
                size="small"
                value={Filters.mobile_number ? Filters.mobile_number : ''}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: '2px solid #A9A9A980 50%', // change border color
                    borderRadius: '8px'
                  },
                  '& fieldset': {
                    borderColor: '#A9A9A980',
                    borderRadius: '8px' // default border color
                  },
                  visibility: 'hidden'
                }}
                onChange={(e) => handleFiltersChange('mobile_number', e.target.value)}
                fullWidth
              />
            </Grid>

            <Grid item md={1} xs={12} mt={3.5}>
              <Button
                sx={{
                  backgroundColor: '#688B2A',
                  color: '#fff',
                  borderRadius: '10px',
                  '&:hover': {
                    backgroundColor: '#688B3A',
                    color: '#fff',
                    borderRadius: '10px'
                  }
                }}
                fullWidth
                onClick={() => handleGet()}
              >
                Search
              </Button>
            </Grid>

            <Grid item md={1} xs={12} mt={3.5}>
              <Button fullWidth variant="contained" color="secondary" onClick={handleClear} sx={{ borderRadius: '10px' }}>
                Clear
              </Button>
            </Grid>
          </Grid>
        </SubCard>
      </Grid>
      <Grid item xs={12}>
        <MainCard sx={{ height: '100%' }}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={AlertOpen}
            autoHideDuration={6000}
            onClose={handleAlertClose}
          >
            <Alert onClose={handleAlertClose} severity={AlertType} variant="filled" sx={{ width: '100%' }}>
              {AlertMessage}
            </Alert>
          </Snackbar>

          <Grid container>
            <Grid item xl={12} lg={12} md={12} sx={{ width: '100%' }}>
              {Data && Data.data && Data.data.length > 0 ? (
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#F8FAFC', color: '#592375' }}>
                        <TableCell sx={{ fontWeight: 700, color: '#592375' }}>Name</TableCell>
                        <TableCell align="left" sx={{ fontWeight: 700, color: '#592375' }}>
                          User Type
                        </TableCell>
                        <TableCell align="left" sx={{ fontWeight: 700, color: '#592375' }}>
                          Mobile Number
                        </TableCell>
                        <TableCell align="left" sx={{ fontWeight: 700, color: '#592375' }}>
                          Aadhaar Number
                        </TableCell>
                        <TableCell align="left" sx={{ fontWeight: 700, color: '#592375' }}>
                          Pan Card
                        </TableCell>
                        <TableCell align="left" sx={{ fontWeight: 700, color: '#592375' }}>
                          Email Address
                        </TableCell>
                        <TableCell align="left" sx={{ fontWeight: 700, color: '#592375' }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Data.data.map((row, index) => (
                        <TableRow
                          key={row.name}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: index % 2 === 0 ? '#F5F5F5' : '#fff' }}
                        >
                          <TableCell component="th" scope="row">
                            {row.aadhaar_name}
                          </TableCell>
                          <TableCell align="left">{formattedName(row.user_type)}</TableCell>
                          <TableCell align="left">{row.mobile_number}</TableCell>
                          <TableCell align="left">{row.aadhar_number}</TableCell>
                          <TableCell align="left">{row.pan_number}</TableCell>
                          <TableCell align="left">{row.email_address}</TableCell>
                          {/* ['ds', 'mds', 'fos'].includes(row['user_type']?.toLowerCase()) */}
                          <TableCell align="left">
                            {row['user_type'] === 'DS' ||
                            row['user_type'] === 'MDS' ||
                            row['user_type'] === 'ds' ||
                            row['user_type'] === 'mds' ||
                            row['user_type'] === 'fos' ? (
                              <Button
                                variant="contained"
                                color="primary"
                                // disabled={true}
                                onClick={() => handleButtonClick(row)}
                              >
                                Approve
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                disabled={true}
                                onClick={() => handleButtonClick(row)}
                              >
                                Create Code
                              </Button>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Stack width="100%" textAlign="center" justifyContent="center">
                  <Typography variant="h5" color="#999999">
                    No record found
                  </Typography>
                </Stack>
              )}
            </Grid>
            <Grid item xs={12} display="flex" width="100%" justifyContent="flex-end" mt={1}>
              <Pagination
                count={Data ? (Data.total_items ? Data.total_items / 20 : Math.ceil(Data.data.length / 20)) : 0}
                page={Page}
                onChange={handlePageChange}
                shape="rounded"
              />
            </Grid>
          </Grid>
        </MainCard>
      </Grid>
    </Grid>
  );
};

export default VideoKyc;
